import { type MutationPayload } from 'vuex';
import Store from '../stores/store';
import { EmployeeProfileModuleConstant } from '../constants';
import type { ltFramework } from '@life-time-inc/enterprise-framework-core';

export default class EmployeeProfileStore implements ltFramework.IEmployeeProfileStore {
	public getInitialData(): ltFramework.IEmployeeProfile {
		return (Store.state as ltFramework.IStoreState).employeeProfileModule.employeeProfile;
	}

	public initialize(): Promise<void> {
		return Store.dispatch(
			EmployeeProfileModuleConstant.name + '/' + EmployeeProfileModuleConstant.action.initialize
		);
	}

	public listen(callback: (state: ltFramework.IEmployeeProfile) => void): () => void {
		return Store.subscribe((mutation: MutationPayload, state: ltFramework.IRootState) => {
			if (mutation.type.indexOf(EmployeeProfileModuleConstant.name + '/') !== -1) {
				callback((state as ltFramework.IStoreState).employeeProfileModule.employeeProfile);
			}
		});
	}

	public logout(): Promise<void> {
		return Store.dispatch(
			EmployeeProfileModuleConstant.name + '/' + EmployeeProfileModuleConstant.action.logout
		);
	}
}
